import {
  getRecommendProduct,
  getRecommendProductForHomePage,
} from 'clients/SmartRecommendationClient';

const getRecommendation = ({ ctx, body }) => getRecommendProduct({ ctx, body });

const getRecommendationForHomePage = ({ ctx, body }) =>
  getRecommendProductForHomePage({ ctx, body });

export default { getRecommendation, getRecommendationForHomePage };
